<!-- <div class="container" *ngIf="auth.isLoading$ | async; else loaded">
  ...Loading
</div>

<ng-template #loaded>
 ... Loaded content
</ng-template> -->
<article id="fullpage">
<div class="modules-container">
<section class="section-fullscreen sec-bmc fp-section fp-table active" data-anchor="bmc" id="id-bmc" style="height: 524px;"><div class="fp-tableCell" style="height: 524px;">
    <div class="wrap">
        <div class="sec-bmc-block">
            <h1>Introducing</h1>
            <h2>The behavioral <span style="white-space:nowrap;">marketing cloud<span class="trademark">TM</span></span></h2>

            <div class="product-block">
                <div class="svg-container">
                    <svg id="bx-icon-cms" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 123.33705 106.16214">
                        <defs>
                            <style>
                                #bx-icon-cms .cls-1 {
                                    fill: none;
                                }

                                #bx-icon-cms .cls-2,
                                #bx-icon-cms .cls-6 {
                                    fill: #c4e1f6;
                                }

                                #bx-icon-cms .cls-11,
                                #bx-icon-cms .cls-16,
                                #bx-icon-cms .cls-2,
                                #bx-icon-cms .cls-6,
                                #bx-icon-cms .cls-7,
                                #bx-icon-cms .cls-9 {
                                    stroke: #395c7a;
                                }

                                #bx-icon-cms .cls-11,
                                #bx-icon-cms .cls-13,
                                #bx-icon-cms .cls-14,
                                #bx-icon-cms .cls-16,
                                #bx-icon-cms .cls-2,
                                #bx-icon-cms .cls-3,
                                #bx-icon-cms .cls-4,
                                #bx-icon-cms .cls-6,
                                #bx-icon-cms .cls-7,
                                #bx-icon-cms .cls-9 {
                                    stroke-miterlimit: 10;
                                }

                                #bx-icon-cms .cls-11,
                                #bx-icon-cms .cls-13,
                                #bx-icon-cms .cls-14,
                                #bx-icon-cms .cls-16,
                                #bx-icon-cms .cls-2,
                                #bx-icon-cms .cls-6,
                                #bx-icon-cms .cls-7,
                                #bx-icon-cms .cls-9 {
                                    stroke-width: 0.15px;
                                }

                                #bx-icon-cms .cls-2 {
                                    opacity: 0.6;
                                }

                                #bx-icon-cms .cls-3,
                                #bx-icon-cms .cls-4 {
                                    stroke: #c4e1f6;
                                    stroke-width: 0.02909px;
                                }

                                #bx-icon-cms .cls-3 {
                                    fill: url(www.bouncd.com#cms-linear-gradient);
                                }

                                #bx-icon-cms .cls-4 {
                                    fill: url(www.bouncd.com#cms-linear-gradient-2);
                                }

                                #bx-icon-cms .cls-5 {
                                    clip-path: url(www.bouncd.com#cms-clip-path);
                                }

                                #bx-icon-cms .cls-13,
                                #bx-icon-cms .cls-6 {
                                    opacity: 0.5;
                                }

                                #bx-icon-cms .cls-7 {
                                    fill: url(www.bouncd.com#cms-linear-gradient-3);
                                }

                                #bx-icon-cms .cls-8 {
                                    clip-path: url(www.bouncd.com#cms-clip-path-2);
                                }

                                #bx-icon-cms .cls-9 {
                                    fill: url(www.bouncd.com#cms-linear-gradient-4);
                                }

                                #bx-icon-cms .cls-10 {
                                    clip-path: url(www.bouncd.com#cms-clip-path-3);
                                }

                                #bx-icon-cms .cls-11 {
                                    fill: url(www.bouncd.com#cms-linear-gradient-5);
                                }

                                #bx-icon-cms .cls-12 {
                                    clip-path: url(www.bouncd.com#cms-clip-path-4);
                                }

                                #bx-icon-cms .cls-13 {
                                    fill: #facdaf;
                                }

                                #bx-icon-cms .cls-13,
                                #bx-icon-cms .cls-14 {
                                    stroke: #ff7f00;
                                }

                                #bx-icon-cms .cls-14 {
                                    fill: url(www.bouncd.com#cms-linear-gradient-6);
                                }

                                #bx-icon-cms .cls-15 {
                                    clip-path: url(www.bouncd.com#cms-clip-path-5);
                                }

                                #bx-icon-cms .cls-16 {
                                    fill: url(www.bouncd.com#cms-linear-gradient-7);
                                }

                                @-webkit-keyframes pulse {
                                    0% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 5px);
                                        transform: translate(0, 5px);
                                    }
                                }

                                @keyframes pulse {
                                    0% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 5px);
                                        transform: translate(0, 5px);
                                    }
                                }

                                @-webkit-keyframes cmsBlue {
                                    0% {
                                        -webkit-transform: translate(0, 28px);
                                        transform: translate(0, 28px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 28px);
                                        transform: translate(0, 28px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes cmsBlue {
                                    0% {
                                        -webkit-transform: translate(0, 28px);
                                        transform: translate(0, 28px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 28px);
                                        transform: translate(0, 28px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes cmsBlue2 {
                                    0% {
                                        -webkit-transform: translate(0, 34px);
                                        transform: translate(0, 34px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 34px);
                                        transform: translate(0, 34px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes cmsBlue2 {
                                    0% {
                                        -webkit-transform: translate(0, 34px);
                                        transform: translate(0, 34px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 34px);
                                        transform: translate(0, 34px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes cmsBlue3 {
                                    0% {
                                        -webkit-transform: translate(0, 30px);
                                        transform: translate(0, 30px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 30px);
                                        transform: translate(0, 30px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes cmsBlue3 {
                                    0% {
                                        -webkit-transform: translate(0, 30px);
                                        transform: translate(0, 30px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 30px);
                                        transform: translate(0, 30px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes cmsOrange {
                                    0% {
                                        -webkit-transform: translate(0, 26px);
                                        transform: translate(0, 26px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 26px);
                                        transform: translate(0, 26px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes cmsOrange {
                                    0% {
                                        -webkit-transform: translate(0, 26px);
                                        transform: translate(0, 26px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 26px);
                                        transform: translate(0, 26px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes cmsBlue4 {
                                    0% {
                                        -webkit-transform: translate(0, 13px);
                                        transform: translate(0, 13px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 13px);
                                        transform: translate(0, 13px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes cmsBlue4 {
                                    0% {
                                        -webkit-transform: translate(0, 13px);
                                        transform: translate(0, 13px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 13px);
                                        transform: translate(0, 13px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                #bx-icon-cms #cms-glass g g {
                                    -webkit-transition: transform 0.1s ease 0s;
                                    transition: transform 0.1s ease 0s;
                                    -webkit-transform: translate(0, 0);
                                    transform: translate(0, 0);
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-delay: 0s;
                                    animation-delay: 0s;
                                    -webkit-animation-iteration-count: infinite;
                                    animation-iteration-count: infinite;
                                    -webkit-animation-direction: alternate-reverse;
                                    animation-direction: alternate-reverse;
                                    -webkit-animation-fill-mode: both;
                                    animation-fill-mode: both;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                    -webkit-animation-name: pulse;
                                    animation-name: pulse;
                                }

                                #bx-icon-cms #cms-blue {
                                    animation-duration: 1.5s;
                                    -webkit-animation-duration: 1.5s;
                                }

                                #bx-icon-cms #cms-blue-2 {
                                    animation-duration: 2s;
                                    -webkit-animation-duration: 2s;
                                }

                                #bx-icon-cms #cms-blue-3 {
                                    animation-duration: 2.5s;
                                    -webkit-animation-duration: 2.5s;
                                }

                                #bx-icon-cms #cms-orange {
                                    animation-duration: 1.75s;
                                    -webkit-animation-duration: 1.75s;
                                }

                                #bx-icon-cms #cms-blue-4 {
                                    animation-duration: 2.25s;
                                    -webkit-animation-duration: 2.25s;
                                }

                                #bx-icon-cms:hover #cms-glass g g {
                                    -webkit-animation-duration: 0.5s;
                                    animation-duration: 0.5s;
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-iteration-count: 1;
                                    animation-iteration-count: 1;
                                    -webkit-animation-direction: normal;
                                    animation-direction: normal;
                                    -webkit-animation-fill-mode: forwards;
                                    animation-fill-mode: forwards;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                }

                                #bx-icon-cms:hover #cms-glass g #cms-blue {
                                    -webkit-transform: translate(0, 28px);
                                    transform: translate(0, 28px);
                                    -webkit-animation-delay: 0.1s;
                                    animation-delay: 0.1s;
                                    -webkit-animation-name: cmsBlue;
                                    animation-name: cmsBlue;
                                }

                                #bx-icon-cms:hover #cms-glass g #cms-blue-2 {
                                    -webkit-transform: translate(0, 34px);
                                    transform: translate(0, 34px);
                                    -webkit-animation-delay: 0.2s;
                                    animation-delay: 0.2s;
                                    -webkit-animation-name: cmsBlue2;
                                    animation-name: cmsBlue2;
                                }

                                #bx-icon-cms:hover #cms-glass g #cms-blue-3 {
                                    -webkit-transform: translate(0, 30px);
                                    transform: translate(0, 30px);
                                    -webkit-animation-delay: 0.3s;
                                    animation-delay: 0.3s;
                                    -webkit-animation-name: cmsBlue3;
                                    animation-name: cmsBlue3;
                                }

                                #bx-icon-cms:hover #cms-glass g #cms-orange {
                                    -webkit-transform: translate(0, 26px);
                                    transform: translate(0, 26px);
                                    -webkit-animation-delay: 0.4s;
                                    animation-delay: 0.4s;
                                    -webkit-animation-name: cmsOrange;
                                    animation-name: cmsOrange;
                                }

                                #bx-icon-cms:hover #cms-glass g #cms-blue-4 {
                                    -webkit-transform: translate(0, 13px);
                                    transform: translate(0, 13px);
                                    -webkit-animation-delay: 0.5s;
                                    animation-delay: 0.5s;
                                    -webkit-animation-name: cmsBlue4;
                                    animation-name: cmsBlue4;
                                }
                            </style>
                            <linearGradient id="cms-linear-gradient" x1="17.3105" y1="89.79829" x2="110.76011" y2="89.79829" gradientTransform="matrix(-1, 0, 0, 1, 140.57173, -29.98875)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#78a3ca"></stop>
                                <stop offset="1" stop-color="#395c7a"></stop>
                            </linearGradient>

                            <linearGradient id="cms-linear-gradient-2" x1="17.3105" y1="89.79829" x2="110.76011" y2="89.79829" gradientTransform="matrix(-1, 0, 0, 1, 140.57173, -29.98875)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#78a3ca"></stop>
                                <stop offset="1" stop-color="#395c7a"></stop>
                            </linearGradient>

                            <clipPath id="cms-clip-path" transform="translate(-19.42827 -29.98875)">
                                <polygon class="cls-1" points="71.39 37.251 66.298 34.363 60.588 37.593 60.667 37.637 60.588 65 65.734 67.887 71.39 64.658 71.308 37.298 71.39 37.251"></polygon>
                            </clipPath>

                            <linearGradient id="cms-linear-gradient-3" x1="88.60966" y1="37.4213" x2="99.41176" y2="37.4213" gradientTransform="matrix(-1, 0, 0, 1, 140.57173, -29.98875)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="cms-clip-path-2" transform="translate(-19.42827 -29.98875)">
                                <polygon class="cls-1" points="110.798 46.541 110.923 46.475 82.737 30.076 76.593 33.66 77.455 34.146 76.826 33.913 76.593 67.506 104.923 83.513 110.923 80.322 111.102 46.654 110.798 46.541"></polygon>
                            </clipPath>

                            <linearGradient id="cms-linear-gradient-4" x1="49.07698" y1="39.87089" x2="83.40711" y2="39.87089" gradientTransform="matrix(-1, 0, 0, 1, 140.57173, -29.98875)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="cms-clip-path-3" transform="translate(-19.42827 -29.98875)">
                                <polygon class="cls-1" points="124.086 66.406 95.635 50.402 93.207 51.684 93 51.682 93 81.476 121.821 97.407 123.985 96.195 123.96 66.45 124.086 66.406"></polygon>
                            </clipPath>

                            <linearGradient id="cms-linear-gradient-5" x1="35.91363" y1="59.00996" x2="66.59427" y2="59.00996" gradientTransform="matrix(-1, 0, 0, 1, 140.57173, -29.98875)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="cms-clip-path-4" transform="translate(-19.42827 -29.98875)">
                                <polygon class="cls-1" points="105.509 79.925 92.056 72.009 74.723 81.012 74.549 81.018 74.546 81.104 74.448 81.155 74.543 81.207 73.747 106.722 87.79 114.658 105.493 105.678 106.24 79.9 105.509 79.925"></polygon>
                            </clipPath>
                            <linearGradient id="cms-linear-gradient-6" x1="54.13341" y1="80.44904" x2="85.55232" y2="80.44904" gradientTransform="matrix(-1, 0, 0, 1, 140.57173, -29.98875)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#facdaf"></stop>
                                <stop offset="1" stop-color="#ff7f00"></stop>
                            </linearGradient>
                            <clipPath id="cms-clip-path-5" transform="translate(-19.42827 -29.98875)">
                                <polygon class="cls-1" points="81.492 104.884 68.303 97.457 61.244 100.985 61 100.965 61 101 61.394 101 61.342 101 61.406 113.396 74.749 121.588 80.983 118.051 81.319 105.024 81.256 105.013 81.492 104.884"></polygon>
                            </clipPath>

                            <linearGradient id="cms-linear-gradient-7" x1="78.50847" y1="102.99562" x2="98.71085" y2="102.99562" gradientTransform="matrix(-1, 0, 0, 1, 140.57173, -29.98875)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                        </defs>
                        <title>isometric_icon_cms</title>
                        <g id="cms-cms-group">
                            <g id="cms-base">
                                <g>
                                    <polygon id="cms-light" class="cls-2" points="29.731 40.205 29.905 34.095 123.261 59.601 123.182 65.204 51.904 106.075 30.09 93.108 30.227 85.995 76.525 66.071 29.731 40.205"></polygon>
                                    <polygon id="cms-dark" class="cls-3" points="51.904 98.925 123.261 59.601 54.016 20.694 29.812 34.17 77.805 60.473 30.227 85.995 51.904 98.925"></polygon>
                                </g>
                                <g>
                                    <polygon id="cms-light-2" data-name="light" class="cls-2" points="3.741 54.621 3.915 48.511 42.429 58.464 42.429 66.658 12.074 82.567 0.175 75.621 0.297 68.327 18.928 63.197 3.741 54.621"></polygon>
                                    <polygon id="cms-dark-2" data-name="dark" class="cls-4" points="11.809 75.282 43.008 58.077 15.238 42.261 3.759 48.511 20.004 57.612 0.03 68.24 11.809 75.282"></polygon>
                                </g>
                            </g>
                            <g id="cms-glass">
                                <g class="cls-5">
                                    <g id="cms-blue">
                                        <polygon id="cms-trans" class="cls-6" points="46.306 37.898 41.16 35.011 41.239 7.613 51.88 7.258 51.962 34.67 46.306 37.898"></polygon>
                                        <polygon id="cms-solid" class="cls-7" points="46.306 10.491 41.16 7.604 46.87 4.374 51.962 7.262 46.306 10.491"></polygon>
                                    </g>
                                </g>
                                <g class="cls-8">
                                    <g id="cms-blue-2" data-name="blue">
                                        <polygon id="cms-trans-2" data-name="trans" class="cls-6" points="85.494 53.524 91.495 50.333 91.674 16.666 57.398 3.924 57.165 37.518 85.494 53.524"></polygon>
                                        <polygon id="cms-solid-2" data-name="solid" class="cls-9" points="85.494 19.677 91.495 16.486 63.309 0.087 57.165 3.671 85.494 19.677"></polygon>
                                    </g>
                                </g>
                                <g class="cls-10">
                                    <g id="cms-blue-3" data-name="blue">
                                        <polygon id="cms-trans-3" data-name="trans" class="cls-6" points="102.596 67.419 104.658 66.206 104.582 36.421 73.977 21.693 73.977 51.487 102.596 67.419"></polygon>
                                        <polygon id="cms-solid-3" data-name="solid" class="cls-11" points="102.596 37.629 104.658 36.417 76.207 20.414 73.977 21.697 102.596 37.629"></polygon>
                                    </g>
                                </g>
                                <g class="cls-12">
                                    <g id="cms-orange">
                                        <polygon id="cms-trans-4" data-name="trans" class="cls-13" points="68.362 84.669 86.064 75.689 86.812 49.911 55.12 51.029 54.319 76.733 68.362 84.669"></polygon>
                                        <polygon id="cms-solid-4" data-name="solid" class="cls-14" points="68.974 58.9 86.438 50.147 72.627 42.02 55.019 51.166 68.974 58.9"></polygon>
                                    </g>
                                </g>
                                <g class="cls-15">
                                    <g id="cms-blue-4" data-name="blue">
                                        <polygon id="cms-trans-5" data-name="trans" class="cls-6" points="55.308 91.608 61.549 88.067 61.887 75.037 41.861 70.976 41.951 83.425 55.308 91.608"></polygon>
                                        <polygon id="cms-solid-5" data-name="solid" class="cls-16" points="55.398 78.545 62.063 74.895 48.875 67.469 41.861 71.047 55.398 78.545"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <h3>Behavioral CMS</h3>
                <h4>The bouncd Core Platform</h4>
            </div>

            <div class="product-block">
                <div class="svg-container">
                    <svg id="bx-icon-email" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 114.57365 106.3041">
                        <defs>
                            <style>
                                #bx-icon-email .cls-1 {
                                    fill: none;
                                }

                                #bx-icon-email .cls-2 {
                                    fill: url(www.bouncd.com#email-linear-gradient);
                                }

                                #bx-icon-email .cls-3 {
                                    fill: url(www.bouncd.com#email-linear-gradient-2);
                                }

                                #bx-icon-email .cls-13,
                                #bx-icon-email .cls-4,
                                #bx-icon-email .cls-5,
                                #bx-icon-email .cls-8 {
                                    fill: #c4e1f6;
                                }

                                #bx-icon-email .cls-11,
                                #bx-icon-email .cls-14,
                                #bx-icon-email .cls-15,
                                #bx-icon-email .cls-20,
                                #bx-icon-email .cls-5,
                                #bx-icon-email .cls-8,
                                #bx-icon-email .cls-9 {
                                    stroke: #395c7a;
                                }

                                #bx-icon-email .cls-11,
                                #bx-icon-email .cls-13,
                                #bx-icon-email .cls-14,
                                #bx-icon-email .cls-15,
                                #bx-icon-email .cls-17,
                                #bx-icon-email .cls-18,
                                #bx-icon-email .cls-20,
                                #bx-icon-email .cls-5,
                                #bx-icon-email .cls-6,
                                #bx-icon-email .cls-8,
                                #bx-icon-email .cls-9 {
                                    stroke-miterlimit: 10;
                                }

                                #bx-icon-email .cls-11,
                                #bx-icon-email .cls-14,
                                #bx-icon-email .cls-15,
                                #bx-icon-email .cls-17,
                                #bx-icon-email .cls-18,
                                #bx-icon-email .cls-20,
                                #bx-icon-email .cls-5,
                                #bx-icon-email .cls-8,
                                #bx-icon-email .cls-9 {
                                    stroke-width: 0.15px;
                                }

                                #bx-icon-email .cls-5 {
                                    opacity: 0.6;
                                }

                                #bx-icon-email .cls-6 {
                                    stroke: #c4e1f6;
                                    stroke-width: 0.03319px;
                                }

                                #bx-icon-email .cls-21,
                                #bx-icon-email .cls-6 {
                                    fill: url(www.bouncd.com#email-linear-gradient-3);
                                }

                                #bx-icon-email .cls-7 {
                                    clip-path: url(www.bouncd.com#email-clip-path);
                                }

                                #bx-icon-email .cls-17,
                                #bx-icon-email .cls-8 {
                                    opacity: 0.5;
                                }

                                #bx-icon-email .cls-9 {
                                    fill: url(www.bouncd.com#email-linear-gradient-4);
                                }

                                #bx-icon-email .cls-10 {
                                    clip-path: url(www.bouncd.com#email-clip-path-2);
                                }

                                #bx-icon-email .cls-11 {
                                    fill: url(www.bouncd.com#email-linear-gradient-5);
                                }

                                #bx-icon-email .cls-12 {
                                    clip-path: url(www.bouncd.com#email-clip-path-3);
                                }

                                #bx-icon-email .cls-13 {
                                    stroke: #78a3ca;
                                    stroke-width: 0.03319px;
                                    opacity: 0.3;
                                }

                                #bx-icon-email .cls-14 {
                                    fill: url(www.bouncd.com#email-linear-gradient-6);
                                }

                                #bx-icon-email .cls-15 {
                                    fill: url(www.bouncd.com#email-linear-gradient-7);
                                }

                                #bx-icon-email .cls-16 {
                                    clip-path: url(www.bouncd.com#email-clip-path-4);
                                }

                                #bx-icon-email .cls-17 {
                                    fill: #facdaf;
                                }

                                #bx-icon-email .cls-17,
                                #bx-icon-email .cls-18 {
                                    stroke: #ff7f00;
                                }

                                #bx-icon-email .cls-18 {
                                    fill: url(www.bouncd.com#email-linear-gradient-8);
                                }

                                #bx-icon-email .cls-19 {
                                    clip-path: url(www.bouncd.com#email-clip-path-5);
                                }

                                #bx-icon-email .cls-20 {
                                    fill: url(www.bouncd.com#email-linear-gradient-9);
                                }

                                @-webkit-keyframes pulse {
                                    0% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 5px);
                                        transform: translate(0, 5px);
                                    }
                                }

                                @keyframes pulse {
                                    0% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 5px);
                                        transform: translate(0, 5px);
                                    }
                                }

                                @-webkit-keyframes emailBlue {
                                    0% {
                                        -webkit-transform: translate(0, 46px);
                                        transform: translate(0, 46px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 46px);
                                        transform: translate(0, 46px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes emailBlue {
                                    0% {
                                        -webkit-transform: translate(0, 46px);
                                        transform: translate(0, 46px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 46px);
                                        transform: translate(0, 46px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes emailBlue2 {
                                    0% {
                                        -webkit-transform: translate(0, 31px);
                                        transform: translate(0, 31px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 31px);
                                        transform: translate(0, 31px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes emailBlue2 {
                                    0% {
                                        -webkit-transform: translate(0, 31px);
                                        transform: translate(0, 31px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 31px);
                                        transform: translate(0, 31px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes emailBlue3 {
                                    0% {
                                        -webkit-transform: translate(0, 20px);
                                        transform: translate(0, 20px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 20px);
                                        transform: translate(0, 20px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes emailBlue3 {
                                    0% {
                                        -webkit-transform: translate(0, 20px);
                                        transform: translate(0, 20px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 20px);
                                        transform: translate(0, 20px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes emailOrange {
                                    0% {
                                        -webkit-transform: translate(0, 60px);
                                        transform: translate(0, 60px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 60px);
                                        transform: translate(0, 60px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes emailOrange {
                                    0% {
                                        -webkit-transform: translate(0, 60px);
                                        transform: translate(0, 60px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 60px);
                                        transform: translate(0, 60px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes emailBlue6 {
                                    0% {
                                        -webkit-transform: translate(0, 12px);
                                        transform: translate(0, 12px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 12px);
                                        transform: translate(0, 12px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes emailBlue6 {
                                    0% {
                                        -webkit-transform: translate(0, 12px);
                                        transform: translate(0, 12px);
                                    }
                                    25% {
                                        -webkit-transform: translate(0, 12px);
                                        transform: translate(0, 12px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                #bx-icon-email #email-glass g g {
                                    -webkit-transition: transform 0.1s ease 0s;
                                    transition: transform 0.1s ease 0s;
                                    -webkit-transform: translate(0, 0);
                                    transform: translate(0, 0);
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-delay: 0s;
                                    animation-delay: 0s;
                                    -webkit-animation-iteration-count: infinite;
                                    animation-iteration-count: infinite;
                                    -webkit-animation-direction: alternate-reverse;
                                    animation-direction: alternate-reverse;
                                    -webkit-animation-fill-mode: both;
                                    animation-fill-mode: both;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                    -webkit-animation-name: pulse;
                                    animation-name: pulse;
                                }

                                #bx-icon-email #email-blue {
                                    animation-duration: 1.5s;
                                    -webkit-animation-duration: 1.5s;
                                }

                                #bx-icon-email #email-blue-2 {
                                    animation-duration: 2s;
                                    -webkit-animation-duration: 2s;
                                }

                                #bx-icon-email #email-blue-3 {
                                    animation-duration: 2.5s;
                                    -webkit-animation-duration: 2.5s;
                                }

                                #bx-icon-email #email-orange {
                                    animation-duration: 1.75s;
                                    -webkit-animation-duration: 1.75s;
                                }

                                #bx-icon-email #email-blue-6 {
                                    animation-duration: 2.25s;
                                    -webkit-animation-duration: 2.25s;
                                }

                                #bx-icon-email:hover #email-glass g g {
                                    -webkit-animation-duration: 0.5s;
                                    animation-duration: 0.5s;
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-iteration-count: 1;
                                    animation-iteration-count: 1;
                                    -webkit-animation-direction: normal;
                                    animation-direction: normal;
                                    -webkit-animation-fill-mode: forwards;
                                    animation-fill-mode: forwards;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                }

                                #bx-icon-email:hover #email-glass g #email-blue {
                                    -webkit-transform: translate(0, 46px);
                                    transform: translate(0, 46px);
                                    -webkit-animation-delay: 0.1s;
                                    animation-delay: 0.1s;
                                    -webkit-animation-name: emailBlue;
                                    animation-name: emailBlue;
                                }

                                #bx-icon-email:hover #email-glass g #email-blue-2 {
                                    -webkit-transform: translate(0, 31px);
                                    transform: translate(0, 31px);
                                    -webkit-animation-delay: 0.2s;
                                    animation-delay: 0.2s;
                                    -webkit-animation-name: emailBlue2;
                                    animation-name: emailBlue2;
                                }

                                #bx-icon-email:hover #email-glass g #email-blue-3 {
                                    -webkit-transform: translate(0, 20px);
                                    transform: translate(0, 20px);
                                    -webkit-animation-delay: 0.3s;
                                    animation-delay: 0.3s;
                                    -webkit-animation-name: emailBlue3;
                                    animation-name: emailBlue3;
                                }

                                #bx-icon-email:hover #email-glass g #email-orange {
                                    -webkit-transform: translate(0, 60px);
                                    transform: translate(0, 60px);
                                    -webkit-animation-delay: 0.4s;
                                    animation-delay: 0.4s;
                                    -webkit-animation-name: emailOrange;
                                    animation-name: emailOrange;
                                }

                                #bx-icon-email:hover #email-glass g #email-blue-6 {
                                    -webkit-transform: translate(0, 12px);
                                    transform: translate(0, 12px);
                                    -webkit-animation-delay: 0.5s;
                                    animation-delay: 0.5s;
                                    -webkit-animation-name: emailBlue6;
                                    animation-name: emailBlue6;
                                }
                            </style>
                            <linearGradient id="email-linear-gradient" x1="61.67306" y1="87.49584" x2="135.81599" y2="87.49584" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#395c7a"></stop>
                                <stop offset="1" stop-color="#78a3ca"></stop>
                            </linearGradient>

                            <linearGradient id="email-linear-gradient-2" x1="17.02646" y1="62.3453" x2="109.63361" y2="62.3453" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#78a3ca"></stop>
                                <stop offset="1" stop-color="#395c7a"></stop>
                            </linearGradient>

                            <linearGradient id="email-linear-gradient-3" x1="0.14188" y1="71.04566" x2="114.49991" y2="71.04566" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#78a3ca"></stop>
                                <stop offset="1" stop-color="#395c7a"></stop>
                            </linearGradient>

                            <clipPath id="email-clip-path" transform="translate(-22.67481 -26.34784)">
                                <polygon class="cls-1" points="78.439 28.164 75.49 26.434 62.981 33.499 63.106 33.568 63.555 79.114 66.285 80.619 78.333 73.937 78.333 28.162 78.439 28.164"></polygon>
                            </clipPath>

                            <linearGradient id="email-linear-gradient-4" x1="40.3338" y1="4.47619" x2="55.88284" y2="4.47619" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="email-clip-path-2" transform="translate(-22.67481 -26.34784)">
                                <polygon class="cls-1" points="82.529 52.436 79.626 50.706 71.181 55.535 71.226 55.547 71.165 55.567 71.614 86.74 74.254 88.245 82.333 83.767 82.333 52.434 82.529 52.436"></polygon>
                            </clipPath>

                            <linearGradient id="email-linear-gradient-5" x1="48.55646" y1="27.62987" x2="60.06368" y2="27.62987" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="email-clip-path-3" transform="translate(-22.67481 -26.34784)">
                                <polygon class="cls-1" points="96.051 66 96.169 65.627 88.457 61.111 81.579 64.935 81.69 64.961 81.666 69.107 77.718 66.902 64.333 74.352 64.333 94.167 72.143 98.449 85.487 90.942 85.49 86.771 89.21 88.889 96.164 85.296 96.062 66 96.051 66"></polygon>
                            </clipPath>

                            <linearGradient id="email-linear-gradient-6" x1="58.90382" y1="38.74058" x2="73.49397" y2="38.74058" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <linearGradient id="email-linear-gradient-7" x1="41.80035" y1="46.44687" x2="62.84789" y2="46.44687" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="email-clip-path-4" transform="translate(-22.67481 -26.34784)">
                                <polygon class="cls-1" points="117.904 41.808 118.031 41.734 103.157 33.248 81.507 45.376 81.618 45.386 81.474 98.934 115.338 103.085 118.031 101.67 117.948 41.803 117.904 41.808"></polygon>
                            </clipPath>

                            <linearGradient id="email-linear-gradient-8" x1="58.8324" y1="14.18053" x2="95.35625" y2="14.18053" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#facdaf"></stop>
                                <stop offset="1" stop-color="#ff7f00"></stop>
                            </linearGradient>

                            <clipPath id="email-clip-path-5" transform="translate(-22.67481 -26.34784)">
                                <polygon class="cls-1" points="123.313 92.952 120.302 91.218 114.346 94.562 114.38 94.565 114.326 94.575 114.305 108.347 119.24 108.73 123.313 106.462 123.292 92.964 123.313 92.952"></polygon>
                            </clipPath>

                            <linearGradient id="email-linear-gradient-9" x1="41.80035" y1="46.44687" x2="62.84789" y2="46.44687" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>
                        </defs>
                        <title>isometric_icon_email</title>
                        <g id="email-email-group">
                            <g id="email-bottom_base" data-name="bottom base">
                                <g>
                                    <path id="email-dark" class="cls-2" d="M63.148,68.59719l-1.47492,3.834,61.74853,33.03141,12.3944,0.93191c0-.466-11.92844-28.51643-11.92844-28.51643C123.639,77.87807,63.25131,68.93174,63.148,68.59719Z" transform="translate(-22.67481 -26.34784)">
                                </path></g>
                                <g id="email-dark-2" data-name="dark">
                                    <polygon class="cls-3" points="36.049 74.216 17.026 56.078 41.284 43.249 109.634 81.442 36.049 74.216"></polygon>
                                    <path class="cls-4" d="M58.72408,100.564L39.64449,82.48563l-0.08313-.07876,0.10147-.05381L63.90639,69.49728l0.054-.02866L64.014,69.49851,132.37407,107.672l0.5665,0.31635-0.64542-.06457Zm0,0,73.59741,7.09159-0.07889.25171L63.90429,69.69478,64.01149,69.696,39.73989,82.49872l0.01831-.13235Z" transform="translate(-22.67481 -26.34784)">
                                </path></g>
                                <polygon id="email-light" class="cls-5" points="114.327 82.959 114.064 80.053 38.588 73.896 41.401 38.954 0.194 62.216 0.077 65.204 73.276 106.218 114.327 82.959"></polygon>
                                <polygon id="email-dark-3" data-name="dark" class="cls-6" points="73.431 102.972 0.142 62.419 41.284 39.12 39.146 73.479 114.5 79.893 73.431 102.972"></polygon>
                            </g>
                            <g id="email-glass">
                                <g class="cls-7">
                                    <g id="email-blue">
                                        <polygon id="email-trans" class="cls-8" points="43.726 54.271 40.887 52.766 40.444 7.152 55.883 1.814 55.883 47.589 43.726 54.271"></polygon>
                                        <polygon id="email-solid" class="cls-9" points="43.113 8.866 40.334 7.152 52.872 0.086 55.883 1.82 43.113 8.866"></polygon>
                                    </g>
                                </g>
                                <g class="cls-10">
                                    <g id="email-blue-2" data-name="blue">
                                        <polygon id="email-trans-2" data-name="trans" class="cls-8" points="51.785 61.897 48.945 60.392 48.503 29.219 60.064 26.086 60.064 57.419 51.785 61.897"></polygon>
                                        <polygon id="email-solid-2" data-name="solid" class="cls-11" points="51.336 30.901 48.556 29.187 57.052 24.358 60.064 26.092 51.336 30.901"></polygon>
                                    </g>
                                </g>
                                <g class="cls-12">
                                    <g id="email-blue-3" data-name="blue">
                                        <g id="email-blue-4" data-name="blue">
                                            <polygon id="email-trans-3" data-name="trans" class="cls-13" points="66.544 62.541 73.494 58.642 73.387 39.039 59.015 38.56 58.904 58.18 66.544 62.541"></polygon>
                                            <polygon id="email-trans-4" data-name="trans" class="cls-8" points="62.779 45.061 41.8 48.004 41.8 67.819 49.539 72.101 62.848 64.594 62.779 45.061"></polygon>
                                        </g>
                                        <g id="email-blue-5" data-name="blue">
                                            <polygon id="email-solid-3" data-name="solid" class="cls-14" points="66.544 42.871 73.494 38.972 65.782 34.61 58.904 38.511 66.544 42.871"></polygon>
                                            <polygon id="email-solid-4" data-name="solid" class="cls-15" points="55.114 40.544 41.8 48.004 49.783 52.349 62.848 44.925 55.114 40.544"></polygon>
                                        </g>
                                    </g>
                                </g>
                                <g class="cls-16">
                                    <g id="email-orange">
                                        <polygon id="email-trans-5" data-name="trans" class="cls-17" points="58.799 72.586 58.943 19.028 95.273 15.456 95.356 75.322 92.663 76.737 58.799 72.586"></polygon>
                                        <polygon id="email-solid-5" data-name="solid" class="cls-18" points="84.823 21.461 58.832 19.028 80.482 6.9 95.356 15.386 84.823 21.461"></polygon>
                                    </g>
                                </g>
                                <g class="cls-19">
                                    <g id="email-blue-6" data-name="blue">
                                        <polygon id="email-trans-6" data-name="trans" class="cls-8" points="91.63 81.999 91.651 68.227 100.617 66.604 100.638 80.115 96.565 82.382 91.63 81.999"></polygon>
                                        <polygon id="email-solid-6" data-name="solid" class="cls-20" points="96.822 68.712 91.672 68.214 97.627 64.871 100.638 66.604 96.822 68.712"></polygon>
                                    </g>
                                </g>
                            </g>
                            <g id="email-top_base" data-name="top base">
                                <polygon id="email-dark-4" data-name="dark" class="cls-21" points="41.284 39.12 39.146 73.331 114.5 79.893 73.431 102.972 0.142 62.419 41.284 39.12"></polygon>
                                <g>
                                    <path class="cls-4" d="M137.24846,106.38877l-11.79019-.84-12.07721-.95L99.54274,103.438,85.712,102.18979l-12.05963-1.1517L61.89455,99.82664l11.79025,0.83922L85.762,101.61609l13.83829,1.16132,13.83066,1.2487,12.05963,1.15194Z" transform="translate(-22.67481 -26.34784)">
                                </path></g>
                                <g>
                                    <path class="cls-4" d="M63.81157,65.76255l-0.24124,5.35136c-0.15537,3.21015-.40668,7.48759-0.66241,11.76476-0.2785,4.27574-.56149,8.55121-0.80725,11.75571-0.25638,3.20384-.42731,5.33973-0.42731,5.33973s0.09634-2.14055.24088-5.35138c0.15515-3.21017.40674-7.48759,0.66278-11.76474,0.27881-4.27572.56207-8.55116,0.80759-11.75568C63.6408,67.89845,63.81157,65.76255,63.81157,65.76255Z" transform="translate(-22.67481 -26.34784)">
                                </path></g>
                                <g>
                                    <path class="cls-4" d="M89.98635,103.95562s-0.02371,1.15473-.13763,2.878c-0.06958.86021-.12158,1.86707-0.22995,2.93991-0.107,1.073-.22107,2.21751-0.33521,3.362-0.14377,1.14117-.28757,2.28236-0.42236,3.35221-0.1319,1.07018-.30734,2.0631-0.43112,2.91719-0.273,1.70529-.50821,2.83614-0.50821,2.83614s0.02283-1.15483.137-2.87807c0.06976-.86018.12012-1.86723,0.23013-2.93988,0.10715-1.073.22144-2.21748,0.33569-3.362l0.42285-3.35215c0.13361-1.07.3074-2.0631,0.43137-2.91717C89.752,105.08657,89.98635,103.95562,89.98635,103.95562Z" transform="translate(-22.67481 -26.34784)">
                                </path></g>
                                <g>
                                    <path class="cls-4" d="M57.88744,88.08712l-3.91174.63615c-2.34851.37113-5.48593,0.8222-8.624,1.26882-3.14117.42406-6.283,0.84367-8.64389,1.12511l-3.93735.45147,3.91168-.63651c2.34848-.37135,5.48593-0.82213,8.624-1.26846,3.1412-.42376,6.283-0.84309,8.644-1.12475Z" transform="translate(-22.67481 -26.34784)">
                                </path></g>
                            </g>
                        </g>
                    </svg>

                </div>
                <h3>Behavioral Email</h3>
                <h4>Inbox Retargeting</h4>
            </div>

            <div class="product-block">
                <div class="svg-container">
                    <svg id="bx-icon-aud" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 102.43264 123.44147">
                        <defs>
                            <style>
                                #bx-icon-aud .cls-1 {
                                    fill: none;
                                }

                                #bx-icon-aud .cls-2,
                                #bx-icon-aud .cls-9 {
                                    fill: #c4e1f6;
                                }

                                #bx-icon-aud .cls-10,
                                #bx-icon-aud .cls-11,
                                #bx-icon-aud .cls-13,
                                #bx-icon-aud .cls-15,
                                #bx-icon-aud .cls-2,
                                #bx-icon-aud .cls-4,
                                #bx-icon-aud .cls-9 {
                                    stroke: #395c7a;
                                }

                                #bx-icon-aud .cls-10,
                                #bx-icon-aud .cls-11,
                                #bx-icon-aud .cls-13,
                                #bx-icon-aud .cls-15,
                                #bx-icon-aud .cls-2,
                                #bx-icon-aud .cls-3,
                                #bx-icon-aud .cls-4,
                                #bx-icon-aud .cls-6,
                                #bx-icon-aud .cls-7,
                                #bx-icon-aud .cls-9 {
                                    stroke-miterlimit: 10;
                                }

                                #bx-icon-aud .cls-10,
                                #bx-icon-aud .cls-11,
                                #bx-icon-aud .cls-13,
                                #bx-icon-aud .cls-15,
                                #bx-icon-aud .cls-2,
                                #bx-icon-aud .cls-4,
                                #bx-icon-aud .cls-6,
                                #bx-icon-aud .cls-7,
                                #bx-icon-aud .cls-9 {
                                    stroke-width: 0.15px;
                                }

                                #bx-icon-aud .cls-2 {
                                    opacity: 0.6;
                                }

                                #bx-icon-aud .cls-3 {
                                    stroke: #c4e1f6;
                                    stroke-width: 0.02946px;
                                    fill: url(www.bouncd.com#aud-linear-gradient);
                                }

                                #bx-icon-aud .cls-4 {
                                    fill: url(www.bouncd.com#aud-linear-gradient-2);
                                }

                                #bx-icon-aud .cls-5 {
                                    clip-path: url(www.bouncd.com#aud-clip-path);
                                }

                                #bx-icon-aud .cls-6 {
                                    fill: #facdaf;
                                }

                                #bx-icon-aud .cls-6,
                                #bx-icon-aud .cls-7 {
                                    stroke: #ff7f00;
                                }

                                #bx-icon-aud .cls-6,
                                #bx-icon-aud .cls-9 {
                                    opacity: 0.5;
                                }

                                #bx-icon-aud .cls-7 {
                                    fill: url(www.bouncd.com#aud-linear-gradient-3);
                                }

                                #bx-icon-aud .cls-8 {
                                    clip-path: url(www.bouncd.com#aud-clip-path-2);
                                }

                                #bx-icon-aud .cls-10 {
                                    fill: url(www.bouncd.com#aud-linear-gradient-4);
                                }

                                #bx-icon-aud .cls-11 {
                                    fill: url(www.bouncd.com#aud-linear-gradient-5);
                                }

                                #bx-icon-aud .cls-12 {
                                    clip-path: url(www.bouncd.com#aud-clip-path-3);
                                }

                                #bx-icon-aud .cls-13 {
                                    fill: url(www.bouncd.com#aud-linear-gradient-6);
                                }

                                #bx-icon-aud .cls-14 {
                                    clip-path: url(www.bouncd.com#aud-clip-path-4);
                                }

                                #bx-icon-aud .cls-15 {
                                    fill: url(www.bouncd.com#aud-linear-gradient-7);
                                }

                                @-webkit-keyframes sidewaysPulseLeft {
                                    0% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(-5px, -3px);
                                        transform: translate(-5px, -3px);
                                    }
                                }

                                @keyframes sidewaysPulseLeft {
                                    0% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(-5px, -3px);
                                        transform: translate(-5px, -3px);
                                    }
                                }

                                @-webkit-keyframes audOrange {
                                    0% {
                                        -webkit-transform: translate(-34px, -19px);
                                        transform: translate(-34px, -19px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-34px, -19px);
                                        transform: translate(-34px, -19px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes audOrange {
                                    0% {
                                        -webkit-transform: translate(-34px, -19px);
                                        transform: translate(-34px, -19px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-34px, -19px);
                                        transform: translate(-34px, -19px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes audBlue2 {
                                    0% {
                                        -webkit-transform: translate(-22px, -12px);
                                        transform: translate(-22px, -12px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-22px, -12px);
                                        transform: translate(-22px, -12px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes audBlue2 {
                                    0% {
                                        -webkit-transform: translate(-22px, -12px);
                                        transform: translate(-22px, -12px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-22px, -12px);
                                        transform: translate(-22px, -12px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes audBlue2Solid {
                                    0% {
                                        -webkit-transform: translate(-22px, -12px);
                                        transform: translate(-22px, -12px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-22px, -12px);
                                        transform: translate(-22px, -12px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes audBlue3 {
                                    0% {
                                        -webkit-transform: translate(-20px, -11px);
                                        transform: translate(-20px, -11px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-20px, -11px);
                                        transform: translate(-20px, -11px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes audBlue3 {
                                    0% {
                                        -webkit-transform: translate(-20px, -11px);
                                        transform: translate(-20px, -11px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-20px, -11px);
                                        transform: translate(-20px, -11px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @-webkit-keyframes audBlue4 {
                                    0% {
                                        -webkit-transform: translate(-7px, -4px);
                                        transform: translate(-7px, -4px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-7px, -4px);
                                        transform: translate(-7px, -4px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                @keyframes audBlue4 {
                                    0% {
                                        -webkit-transform: translate(-7px, -4px);
                                        transform: translate(-7px, -4px);
                                    }
                                    25% {
                                        -webkit-transform: translate(-7px, -4px);
                                        transform: translate(-7px, -4px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0, 0px);
                                        transform: translate(0, 0px);
                                    }
                                }

                                #bx-icon-aud #aud-glass g g {
                                    -webkit-transition: transform 0.1s ease 0s;
                                    transition: transform 0.1s ease 0s;
                                    -webkit-transform: translate(0, 0);
                                    transform: translate(0, 0);
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-delay: 0s;
                                    animation-delay: 0s;
                                    -webkit-animation-iteration-count: infinite;
                                    animation-iteration-count: infinite;
                                    -webkit-animation-direction: alternate-reverse;
                                    animation-direction: alternate-reverse;
                                    -webkit-animation-fill-mode: both;
                                    animation-fill-mode: both;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                    -webkit-animation-name: sidewaysPulseLeft;
                                    animation-name: sidewaysPulseLeft;
                                }

                                #bx-icon-aud #aud-orange {
                                    animation-duration: 1.5s;
                                    -webkit-animation-duration: 1.5s;
                                }

                                #bx-icon-aud #aud-blue-2 {
                                    animation-duration: 2s;
                                    -webkit-animation-duration: 2s;
                                }

                                #bx-icon-aud #aud-blue-2 g {
                                    -webkit-transform: translate(0px, 0px);
                                    transform: translate(0px, 0px);
                                }

                                #bx-icon-aud #aud-blue-3 {
                                    animation-duration: 2s;
                                    -webkit-animation-duration: 2s;
                                }

                                #bx-icon-aud #aud-blue-4 {
                                    animation-duration: 2.5s;
                                    -webkit-animation-duration: 2.5s;
                                }

                                #bx-icon-aud #aud-blue-2 g {
                                  transform: translate(1px,1px) !important;
                                }

                                #bx-icon-aud:hover #aud-glass g g {
                                    -webkit-animation-duration: 0.5s;
                                    animation-duration: 0.5s;
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-iteration-count: 1;
                                    animation-iteration-count: 1;
                                    -webkit-animation-direction: normal;
                                    animation-direction: normal;
                                    -webkit-animation-fill-mode: forwards;
                                    animation-fill-mode: forwards;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                }

                                #bx-icon-aud:hover #aud-glass g #aud-orange {
                                    -webkit-transform: translate(-34px, -19px);
                                    transform: translate(-34px, -19px);
                                    -webkit-animation-delay: 0.1s;
                                    animation-delay: 0.1s;
                                    -webkit-animation-name: audOrange;
                                    animation-name: audOrange;
                                }

                                #bx-icon-aud:hover #aud-glass g #aud-blue-2 {
                                    -webkit-transform: translate(-22px, -12px);
                                    transform: translate(-22px, -12px);
                                    -webkit-animation-delay: 0.2s;
                                    animation-delay: 0.2s;
                                    -webkit-animation-name: audBlue2;
                                    animation-name: audBlue2;
                                }

                                #bx-icon-aud:hover #aud-glass g #aud-blue-2 g {
                                    -webkit-transform: translate(0px, 0px);
                                    transform: translate(0px, 0px);
                                    -webkit-animation: none;
                                    animation: none;
                                }

                                #bx-icon-aud:hover #aud-glass g #aud-blue-3 {
                                    -webkit-transform: translate(-20px, -11px);
                                    transform: translate(-20px, -11px);
                                    -webkit-animation-delay: 0.3s;
                                    animation-delay: 0.3s;
                                    -webkit-animation-name: audBlue3;
                                    animation-name: audBlue3;
                                }

                                #bx-icon-aud:hover #aud-glass g #aud-blue-4 {
                                    -webkit-transform: translate(-7px, -4px);
                                    transform: translate(-7px, -4px);
                                    -webkit-animation-delay: 0.4s;
                                    animation-delay: 0.4s;
                                    -webkit-animation-name: audBlue4;
                                    animation-name: audBlue4;
                                }
                            </style>
                            <linearGradient id="aud-linear-gradient" x1="222.74559" y1="82.05953" x2="301.6496" y2="82.05953" gradientTransform="matrix(-1, 0, 0, 1, 335.35482, 0)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#78a3ca"></stop>
                                <stop offset="1" stop-color="#395c7a"></stop>
                            </linearGradient>

                            <linearGradient id="aud-linear-gradient-2" x1="261.02574" y1="99.28206" x2="278.71406" y2="99.28206" gradientTransform="matrix(-1, 0, 0, 1, 305.4932, -19.2565)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="aud-clip-path" transform="translate(-29.86162 -19.2565)">
                                <polygon class="cls-1" points="132.182 91.753 98.146 72.717 76.191 85.052 76.346 101.422 110.171 120.584 110.438 120.234 132.084 108.016 132.182 91.753"></polygon>
                            </clipPath>

                            <linearGradient id="aud-linear-gradient-3" x1="203.17266" y1="106.09093" x2="225.26119" y2="106.09093" gradientTransform="matrix(-1, 0, 0, 1, 305.4932, -19.2565)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#facdaf"></stop>
                                <stop offset="1" stop-color="#ff7f00"></stop>
                            </linearGradient>

                            <clipPath id="aud-clip-path-2" transform="translate(-29.86162 -19.2565)">
                                <polygon class="cls-1" points="119.333 79.784 117.32 81.014 119.35 79.622 97.931 67.752 55.333 91.608 55.333 92.958 54.243 92.306 47.333 96.146 47.333 103.012 68.333 114.449 68.333 114.768 75.333 110.628 75.333 108.655 77.333 109.48 77.333 109.8 77.637 109.64 77.656 109.645 77.547 109.594 119.333 85.958 119.333 79.784"></polygon>
                            </clipPath>

                            <linearGradient id="aud-linear-gradient-4" x1="215.65217" y1="94.79237" x2="257.98475" y2="94.79237" gradientTransform="matrix(-1, 0, 0, 1, 305.4932, -19.2565)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <linearGradient id="aud-linear-gradient-5" x1="259.45463" y1="109.52721" x2="266.80404" y2="109.52721" gradientTransform="matrix(-1, 0, 0, 1, 305.4932, -19.2565)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="aud-clip-path-3" transform="translate(-29.86162 -19.2565)">
                                <polygon class="cls-1" points="98.261 53.167 47.333 81.949 47.333 84.199 66.456 95.027 117.333 66.218 117.333 64.16 98.261 53.167"></polygon>
                            </clipPath>

                            <linearGradient id="aud-linear-gradient-6" x1="217.39623" y1="79.59357" x2="268.5481" y2="79.59357" gradientTransform="matrix(-1, 0, 0, 1, 305.4932, -19.2565)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="aud-clip-path-4" transform="translate(-29.86162 -19.2565)">
                                <polygon class="cls-1" points="104.333 38.219 104.928 38.077 97.892 34.237 47.333 62.748 47.333 79.971 53.655 83.462 53.527 83.21 104.333 54.527 104.333 38.219"></polygon>
                            </clipPath>

                            <linearGradient id="aud-linear-gradient-7" x1="230.1546" y1="60.70006" x2="281.60045" y2="60.70006" gradientTransform="matrix(-1, 0, 0, 1, 305.4932, -19.2565)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                        </defs>
                        <title>isometric_icon_audiences</title>
                        <g id="aud-audiences-group">
                            <g id="aud-base">
                                <g>
                                    <path class="cls-2" d="M43.65221,120.67591c-8.17819-4.06968-13.487-13.65471-13.70847-27.52085-0.41207-25.829,17.12372-56.854,38.96867-68.94417,21.84495-12.09038,39.81223-.92645,39.92766,24.80875,0.11542,25.735-17.42037,56.75994-38.96831,68.94417A38.36806,38.36806,0,0,1,58.279,122.39738c-5.63682,9.55552-14.91943,18.18828-20.112,20.22,0,0-4.51443-1.79725-3.89109-2.47922C43.42783,130.1225,44.07219,123.64564,43.65221,120.67591Z" transform="translate(-29.86162 -19.2565)">
                                </path></g>
                                <g>
                                    <path class="cls-3" d="M47.4208,122.78692c-8.17819-4.06968-13.487-13.65471-13.70847-27.52085C33.30026,69.437,50.83605,38.41209,72.681,26.3219c21.84495-12.09038,39.81223-.92645,39.92766,24.80875,0.11542,25.735-17.42037,56.75994-38.96831,68.94417a38.36806,38.36806,0,0,1-11.59272,4.43357c-8.29326,14.0587-25.94915,19.8698-24.00312,17.74075C47.19642,132.23351,47.84078,125.75665,47.4208,122.78692Z" transform="translate(-29.86162 -19.2565)">
                                </path></g>
                            </g>
                            <g id="aud-glass">
                                <g id="aud-blue">
                                    <polygon id="aud-solid" class="cls-4" points="44.428 66.869 44.467 83.251 26.779 93.182 26.814 76.598 44.428 66.869"></polygon>
                                </g>
                                <g class="cls-5">
                                    <g id="aud-orange">
                                        <polygon id="aud-trans" class="cls-6" points="102.321 72.496 68.285 53.461 46.329 65.796 46.485 82.165 80.31 101.328 102.321 72.496"></polygon>
                                        <polygon id="aud-solid-2" data-name="solid" class="cls-7" points="80.387 84.803 102.321 72.496 102.223 88.76 80.232 101.172 80.387 84.803"></polygon>
                                    </g>
                                </g>
                                <g class="cls-8">
                                    <g id="aud-blue-2" data-name="blue">
                                        <polygon id="aud-trans-2" data-name="trans" class="cls-9" points="89.58 60.365 47.803 90.389 25.809 78.054 25.809 72.351 68.285 48.495 89.58 60.365"></polygon>
                                        <polygon id="aud-trans-3" data-name="trans" class="cls-9" points="46.039 85.03 24.646 73.05 17.663 76.89 17.663 83.756 38.843 95.276 46.039 85.03"></polygon>
                                        <g>
                                            <polygon id="aud-solid-3" data-name="solid" class="cls-10" points="47.508 84.208 89.841 60.528 89.841 66.701 47.508 90.544 47.508 84.208"></polygon>
                                            <polygon id="aud-solid-4" data-name="solid" class="cls-11" points="46.039 85.03 46.039 91.372 38.689 95.511 38.689 89.141 46.039 85.03"></polygon>
                                        </g>
                                    </g>
                                </g>
                                <g class="cls-12">
                                    <g id="aud-blue-3" data-name="blue">
                                        <polygon id="aud-trans-4" data-name="trans" class="cls-9" points="88.097 44.903 36.945 75.771 17.547 64.942 17.547 62.693 68.75 33.91 88.097 44.903"></polygon>
                                        <polygon id="aud-solid-5" data-name="solid" class="cls-13" points="88.097 44.903 88.097 46.961 36.945 75.771 36.945 73.517 88.097 44.903"></polygon>
                                    </g>
                                </g>
                                <g class="cls-14">
                                    <g id="aud-blue-4" data-name="blue">
                                        <polygon id="aud-trans-5" data-name="trans" class="cls-9" points="75.5 18.821 68.285 14.981 17.547 43.491 17.547 60.714 23.831 64.205 75.5 18.821"></polygon>
                                        <polygon id="aud-solid-6" data-name="solid" class="cls-15" points="75.339 18.807 75.339 35.27 23.893 64.08 24.187 47.421 75.339 18.807"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>               
                </div>
                <h3>Behavioral Audiences</h3>
                <h4>People-Based Marketing Automation</h4>
            </div>

            <div class="product-block">
                <div class="svg-container">
                    <svg id="bx-icon-ads" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96.10162 123.98707">
                        <defs>
                            <style>
                            #bx-icon-ads .cls-1 {
                                    fill: none;
                                }

                                #bx-icon-ads .cls-2,
                                #bx-icon-ads .cls-5 {
                                    fill: #c4e1f6;
                                }

                                #bx-icon-ads .cls-11,
                                #bx-icon-ads .cls-12,
                                #bx-icon-ads .cls-14,
                                #bx-icon-ads .cls-16,
                                #bx-icon-ads .cls-2,
                                #bx-icon-ads .cls-5,
                                #bx-icon-ads .cls-6 {
                                    stroke: #395c7a;
                                }

                                #bx-icon-ads .cls-11,
                                #bx-icon-ads .cls-12,
                                #bx-icon-ads .cls-14,
                                #bx-icon-ads .cls-16,
                                #bx-icon-ads .cls-2,
                                #bx-icon-ads .cls-3,
                                #bx-icon-ads .cls-5,
                                #bx-icon-ads .cls-6,
                                #bx-icon-ads .cls-8,
                                #bx-icon-ads .cls-9 {
                                    stroke-miterlimit: 10;
                                }

                                #bx-icon-ads .cls-11,
                                #bx-icon-ads .cls-12,
                                #bx-icon-ads .cls-14,
                                #bx-icon-ads .cls-16,
                                #bx-icon-ads .cls-2,
                                #bx-icon-ads .cls-5,
                                #bx-icon-ads .cls-6,
                                #bx-icon-ads .cls-8,
                                #bx-icon-ads .cls-9 {
                                    stroke-width: 0.15px;
                                }

                                #bx-icon-ads .cls-3 {
                                    stroke: #c4e1f6;
                                    stroke-width: 0.03054px;
                                    fill: url(www.bouncd.com#ads-linear-gradient);
                                }

                                #bx-icon-ads .cls-4 {
                                    clip-path: url(www.bouncd.com#ads-clip-path);
                                }

                                #bx-icon-ads .cls-5,
                                #bx-icon-ads .cls-8 {
                                    opacity: 0.5;
                                }

                                #bx-icon-ads .cls-6 {
                                    fill: url(www.bouncd.com#ads-linear-gradient-2);
                                }

                                #bx-icon-ads .cls-7 {
                                    clip-path: url(www.bouncd.com#ads-clip-path-2);
                                }

                                #bx-icon-ads .cls-8 {
                                    fill: #facdaf;
                                }

                                #bx-icon-ads .cls-8,
                                #bx-icon-ads .cls-9 {
                                    stroke: #ff7f00;
                                }

                                #bx-icon-ads .cls-9 {
                                    fill: url(www.bouncd.com#ads-linear-gradient-3);
                                }

                                #bx-icon-ads .cls-10 {
                                    clip-path: url(www.bouncd.com#ads-clip-path-3);
                                }

                                #bx-icon-ads .cls-11 {
                                    fill: url(www.bouncd.com#ads-linear-gradient-4);
                                }

                                #bx-icon-ads .cls-12 {
                                    fill: url(www.bouncd.com#ads-linear-gradient-5);
                                }

                                #bx-icon-ads .cls-13 {
                                    clip-path: url(www.bouncd.com#ads-clip-path-4);
                                }

                                #bx-icon-ads .cls-14 {
                                    fill: url(www.bouncd.com#ads-linear-gradient-6);
                                }

                                #bx-icon-ads .cls-15 {
                                    clip-path: url(www.bouncd.com#ads-clip-path-5);
                                }

                                #bx-icon-ads .cls-16 {
                                    fill: url(www.bouncd.com#ads-linear-gradient-7);
                                }

                                @-webkit-keyframes sidewaysPulseRight {
                                    0% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(2px, -2px);
                                        transform: translate(2px, -2px);
                                    }
                                }

                                @keyframes sidewaysPulseRight {
                                    0% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                    100% {
                                        -webkit-transform: translate(2px, -2px);
                                        transform: translate(2px, -2px);
                                    }
                                }

                                @-webkit-keyframes adsBlue5 {
                                    0% {
                                        -webkit-transform: translate(2px, -2px);
                                        transform: translate(2px, -2px);
                                    }
                                    25% {
                                        -webkit-transform: translate(2px, -2px);
                                        transform: translate(2px, -2px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @keyframes adsBlue5 {
                                    0% {
                                        -webkit-transform: translate(2px, -2px);
                                        transform: translate(2px, -2px);
                                    }
                                    25% {
                                        -webkit-transform: translate(2px, -2px);
                                        transform: translate(2px, -2px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @-webkit-keyframes adsBlue4 {
                                    0% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    25% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @keyframes adsBlue4 {
                                    0% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    25% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @-webkit-keyframes adsBlue2 {
                                    0% {
                                        -webkit-transform: translate(13px, -7px);
                                        transform: translate(13px, -7px);
                                    }
                                    25% {
                                        -webkit-transform: translate(13px, -7px);
                                        transform: translate(13px, -7px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @keyframes adsBlue2 {
                                    0% {
                                        -webkit-transform: translate(13px, -7px);
                                        transform: translate(13px, -7px);
                                    }
                                    25% {
                                        -webkit-transform: translate(13px, -7px);
                                        transform: translate(13px, -7px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @-webkit-keyframes adsOrange {
                                    0% {
                                        -webkit-transform: translate(36px, -20px);
                                        transform: translate(36px, -20px);
                                    }
                                    25% {
                                        -webkit-transform: translate(36px, -20px);
                                        transform: translate(36px, -20px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @keyframes adsOrange {
                                    0% {
                                        -webkit-transform: translate(36px, -20px);
                                        transform: translate(36px, -20px);
                                    }
                                    25% {
                                        -webkit-transform: translate(36px, -20px);
                                        transform: translate(36px, -20px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @-webkit-keyframes adsBlue {
                                    0% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    25% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                @keyframes adsBlue {
                                    0% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    25% {
                                        -webkit-transform: translate(4px, -2px);
                                        transform: translate(4px, -2px);
                                    }
                                    100% {
                                        -webkit-transform: translate(0px, 0px);
                                        transform: translate(0px, 0px);
                                    }
                                }

                                #bx-icon-ads #ads-glass g g {
                                    -webkit-transition: transform 0.1s ease 0s;
                                    transition: transform 0.1s ease 0s;
                                    -webkit-transform: translate(0, 0);
                                    transform: translate(0, 0);
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-delay: 0s;
                                    animation-delay: 0s;
                                    -webkit-animation-iteration-count: infinite;
                                    animation-iteration-count: infinite;
                                    -webkit-animation-direction: alternate-reverse;
                                    animation-direction: alternate-reverse;
                                    -webkit-animation-fill-mode: both;
                                    animation-fill-mode: both;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                    -webkit-animation-name: sidewaysPulseRight;
                                    animation-name: sidewaysPulseRight;
                                }

                                #bx-icon-ads #ads-blue-5 {
                                    animation-duration: 1.5s;
                                    -webkit-animation-duration: 1.5s;
                                }

                                #bx-icon-ads #ads-blue-4 {
                                    animation-duration: 2s;
                                    -webkit-animation-duration: 2s;
                                }

                                #bx-icon-ads #ads-blue-2 {
                                    animation-duration: 2.5s;
                                    -webkit-animation-duration: 2.5s;
                                }

                                #bx-icon-ads #ads-orange {
                                    animation-duration: 1.75s;
                                    -webkit-animation-duration: 1.75s;
                                }

                                #bx-icon-ads #ads-blue {
                                    animation-duration: 2.25s;
                                    -webkit-animation-duration: 2.25s;
                                }

                                #bx-icon-ads:hover #ads-glass g g {
                                    -webkit-animation-duration: 0.5s;
                                    animation-duration: 0.5s;
                                    -webkit-animation-timing-function: ease;
                                    animation-timing-function: ease;
                                    -webkit-animation-iteration-count: 1;
                                    animation-iteration-count: 1;
                                    -webkit-animation-direction: normal;
                                    animation-direction: normal;
                                    -webkit-animation-fill-mode: forwards;
                                    animation-fill-mode: forwards;
                                    -webkit-animation-play-state: running;
                                    animation-play-state: running;
                                }

                                #bx-icon-ads:hover #ads-glass g #ads-blue-5 {
                                    -webkit-transform: translate(2px, -2px);
                                    transform: translate(2px, -2px);
                                    -webkit-animation-delay: 0.1s;
                                    animation-delay: 0.1s;
                                    -webkit-animation-name: adsBlue5;
                                    animation-name: adsBlue5;
                                }

                                #bx-icon-ads:hover #ads-glass g #ads-blue-4 {
                                    -webkit-transform: translate(4px, -2px);
                                    transform: translate(4px, -2px);
                                    -webkit-animation-delay: 0.2s;
                                    animation-delay: 0.2s;
                                    -webkit-animation-name: adsBlue4;
                                    animation-name: adsBlue4;
                                }

                                #bx-icon-ads:hover #ads-glass g #ads-blue-2 {
                                    -webkit-transform: translate(13px, -7px);
                                    transform: translate(13px, -7px);
                                    -webkit-animation-delay: 0.3s;
                                    animation-delay: 0.3s;
                                    -webkit-animation-name: adsBlue2;
                                    animation-name: adsBlue2;
                                }

                                #bx-icon-ads:hover #ads-glass g #ads-blue-2 #ads-blue-3 {
                                    animation: none;
                                    -webkit-animation: none;
                                }

                                #bx-icon-ads:hover #ads-glass g #ads-orange {
                                    -webkit-transform: translate(36px, -20px);
                                    transform: translate(36px, -20px);
                                    -webkit-animation-delay: 0.4s;
                                    animation-delay: 0.4s;
                                    -webkit-animation-name: adsOrange;
                                    animation-name: adsOrange;
                                }

                                #bx-icon-ads:hover #ads-glass g #ads-blue {
                                    -webkit-transform: translate(4px, -2px);
                                    transform: translate(4px, -2px);
                                    -webkit-animation-delay: 0.5s;
                                    animation-delay: 0.5s;
                                    -webkit-animation-name: adsBlue;
                                    animation-name: adsBlue;
                                }
                            </style>
                            <linearGradient id="ads-linear-gradient" x1="36.40441" y1="82.39848" x2="116.88824" y2="82.39848" gradientTransform="matrix(-1, 0, 0, 1, 129.01565, -19.17802)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#78a3ca"></stop>
                                <stop offset="1" stop-color="#395c7a"></stop>
                            </linearGradient>

                            <clipPath id="ads-clip-path" transform="translate(-30.98435 -19.17802)">
                                <polygon class="cls-1" points="66.92 92.333 62.982 94.72 63.095 96.222 97.194 115.454 101 113.282 101 111.544 66.92 92.333"></polygon>
                            </clipPath>

                            <linearGradient id="ads-linear-gradient-2" x1="62.3885" y1="105.08704" x2="96.83246" y2="105.08704" gradientTransform="matrix(-1, 0, 0, 1, 129.01565, -19.17802)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="ads-clip-path-2" transform="translate(-30.98435 -19.17802)">
                                <polygon class="cls-1" points="101 96.257 67.094 76.996 30.857 97.397 31 97.444 31 110.116 65.096 129.125 65.18 129.166 65.079 129.157 65 129.177 65 129.137 101 108.865 101 96.257"></polygon>
                            </clipPath>

                            <linearGradient id="ads-linear-gradient-3" x1="94.42453" y1="113.2931" x2="128.83884" y2="113.2931" gradientTransform="matrix(-1, 0, 0, 1, 129.01565, -19.17802)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#facdaf"></stop>
                                <stop offset="1" stop-color="#ff7f00"></stop>
                            </linearGradient>

                            <clipPath id="ads-clip-path-3" transform="translate(-30.98435 -19.17802)">
                                <polygon class="cls-1" points="72.116 70.318 71 71.034 71 69.531 66.834 67.29 54 74.464 54 74.466 54 74.46 54 82.152 58.21 84.372 58.337 84.393 58.167 84.385 58 84.394 58 84.375 59 83.64 59 85.141 87.969 101.1 88.06 101.27 101 93.973 101 86.477 72.116 70.318"></polygon>
                            </clipPath>

                            <linearGradient id="ads-linear-gradient-4" x1="71.11281" y1="89.31814" x2="100.17661" y2="89.31814" gradientTransform="matrix(-1, 0, 0, 1, 129.01565, -19.17802)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <linearGradient id="ads-linear-gradient-5" x1="101.51416" y1="79.42712" x2="105.52705" y2="79.42712" gradientTransform="matrix(-1, 0, 0, 1, 129.01565, -19.17802)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="ads-clip-path-4" transform="translate(-30.98435 -19.17802)">
                                <polygon class="cls-1" points="66.92 60.563 62.982 62.95 63.095 64.452 97.194 83.684 101 81.512 101 79.774 66.92 60.563"></polygon>
                            </clipPath>

                            <linearGradient id="ads-linear-gradient-6" x1="62.3885" y1="73.31699" x2="96.83246" y2="73.31699" gradientTransform="matrix(-1, 0, 0, 1, 129.01565, -19.17802)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>

                            <clipPath id="ads-clip-path-5" transform="translate(-30.98435 -19.17802)">
                                <polygon class="cls-1" points="75.819 51.141 73 52.703 73 60.394 98.119 74.301 101 72.826 101 65.115 75.819 51.141"></polygon>
                            </clipPath>

                            <linearGradient id="ads-linear-gradient-7" x1="61.13759" y1="63.50201" x2="86.20596" y2="63.50201" gradientTransform="matrix(-1, 0, 0, 1, 129.01565, -19.17802)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#d9edf6"></stop>
                                <stop offset="1" stop-color="#c4e1f6"></stop>
                            </linearGradient>
                        </defs>
                        <title>isometric_icon_ads</title>
                        <g id="ads-ads-group">
                            <g id="ads-base">
                                <polygon class="cls-2" points="15.532 67.311 61.841 2.453 65.1 0.124 96.016 113.052 92.742 115.453 58.48 91.927 53.771 121.504 50.235 123.817 48.426 122.025 45.997 85.206 15.532 67.311"></polygon>
                                <polygon class="cls-3" points="12.127 69.668 61.695 2.48 92.611 115.409 69.391 102.141 55.075 94.284 50.186 123.96 43.417 119.149 42.593 87.563 12.127 69.668"></polygon>
                            </g>
                            <g id="ads-glass">
                                <g class="cls-4">
                                    <g id="ads-blue">
                                        <polygon id="ads-trans" class="cls-5" points="32.183 75.542 36.307 73.155 70.757 92.366 70.757 94.104 66.627 96.276 32.183 75.542"></polygon>
                                        <polygon id="ads-solid" class="cls-6" points="66.627 96.276 32.203 77.044 32.183 75.542 66.598 94.604 66.627 96.276"></polygon>
                                    </g>
                                </g>
                                <g class="cls-7">
                                    <g id="ads-orange">
                                        <polygon id="ads-trans-2" data-name="trans" class="cls-8" points="0.126 78.219 36.456 57.818 70.708 77.079 70.708 89.687 34.236 109.988 0.126 78.219"></polygon>
                                        <polygon id="ads-solid-2" data-name="solid" class="cls-9" points="0.177 78.231 34.591 97.292 34.286 109.999 0.177 90.938 0.177 78.231"></polygon>
                                    </g>
                                </g>
                                <g class="cls-10">
                                    <g id="ads-blue-2" data-name="blue">
                                        <polygon id="ads-trans-3" data-name="trans" class="cls-5" points="36.255 48.112 23.499 55.286 27.471 65.215 40.343 58.133 40.343 50.353 36.255 48.112"></polygon>
                                        <polygon id="ads-trans-4" data-name="trans" class="cls-5" points="41.617 51.14 28.86 58.314 57.602 82.092 70.658 74.795 70.658 67.299 41.617 51.14"></polygon>
                                        <g id="ads-blue-3" data-name="blue">
                                            <polygon id="ads-solid-3" data-name="solid" class="cls-11" points="28.839 58.245 57.903 74.343 57.598 82.035 28.839 65.963 28.839 58.245"></polygon>
                                            <polygon id="ads-solid-4" data-name="solid" class="cls-12" points="27.501 57.505 27.501 65.216 23.489 62.974 23.489 55.282 27.501 57.505"></polygon>
                                        </g>
                                    </g>
                                </g>
                                <g class="cls-13">
                                    <g id="ads-blue-4" data-name="blue">
                                        <polygon id="ads-trans-5" data-name="trans" class="cls-5" points="32.183 43.772 36.307 41.385 70.757 60.596 70.757 62.334 66.627 64.506 32.183 43.772"></polygon>
                                        <polygon id="ads-solid-5" data-name="solid" class="cls-14" points="66.627 64.506 32.203 45.274 32.183 43.772 66.598 62.834 66.627 64.506"></polygon>
                                    </g>
                                </g>
                                <g class="cls-15">
                                    <g id="ads-blue-5" data-name="blue">
                                        <polygon id="ads-trans-6" data-name="trans" class="cls-5" points="42.81 33.525 45.578 31.963 70.708 45.937 70.708 53.648 67.878 55.123 42.81 33.525"></polygon>
                                        <polygon id="ads-solid-6" data-name="solid" class="cls-16" points="42.81 33.525 67.87 47.432 67.878 55.123 42.81 41.216 42.81 33.525"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <h3>Behavioral Ads</h3>
                <h4>High Impact Programmatic Advertisements</h4>
            </div>
        </div>
    </div>
</div>
</section>
   
<header class="section-fullscreen header-homepage header button-dark fp-section fp-table active" data-anchor="header" id="id-header" name="Highest Conversion Revenue" style="height: 524px;"><div class="fp-tableCell" style="height:524px;">
	<div class="wrap">
		<div class="header-wrapper">
			<h1 class="variable">Unlock Your Highest Conversion Revenue.</h1>
			<h4>From Each of  Your Website Visitors.</h4>
		</div>
	</div> 
<div class="fullscreen-height video-module">
    <button class="btn-overlay-video-play header-video">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve" class="injected-svg inject-svg overlay-play-image">
<g>
	<circle opacity="0.5" fill="#F7C2A0" cx="49.6" cy="50" r="47.6"></circle>
	<polygon fill="#FF7F00" points="37.5,75.5 37.5,24.6 72.3,50  "></polygon>
</g>
</svg>
    </button>

    <div class="fullscreen-height overlay-video" data-state="hidden">
      <div class="overlay-video-container">
        <div class="backdrop"> </div>
        <div class="overlay-video-sizer">
        </div>
      </div>
    </div>
</div>

</div>
</header>

<section class="section-fullscreen sec-hello button-dark fp-section fp-table active" data-anchor="hello" id="id-hello" data-module="home-hello" style="height: 524px;"><div class="fp-tableCell" style="height:524px;">
        <div class="wrap">
            <div class="sec-hello-block">
            
                <h1>Hello</h1>
                <h2>Behavioral Automation.</h2>
                <h4>Your visitors all behave differently.<hr class="break"> Why treat them all the same?</h4>
                <div class="product-container">

                    <div class="product-block">
                                            <div class="image-product_block">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="injected-svg image-product image-product-segmentation inject-svg icon-animation" x="0px" y="0px" viewBox="0 0 78.9 79.6" style="enable-background:new 0 0 78.9 79.6;" xml:space="preserve">
                    <g>
                        <g>
                            <g>
                                <path class="image-segment-small" d="M37.6,48.3l5.6,0.8l1.8-5.2l-4.9-3.2c0.1-0.5,0.1-1,0.1-1.5c0-0.8-0.1-1.5-0.2-2.3l4.9-3.1l-1.8-5.2     l-5.9,0.8c-0.7-1.1-1.5-2-2.5-2.8l1.8-5.5l-4.8-2.7l-3.9,4.4c-1.2-0.4-2.5-0.5-3.8-0.7l-2.2-5.3l-5.4,0.9l-0.2,5.7     c-1.2,0.5-2.5,1.2-3.5,2l-4.9-2.6L4.3,27l3.4,4.3c-0.7,1.2-1.2,2.6-1.5,4L1,36.4v5.5l5.2,1.1c0.3,1.5,0.8,2.8,1.5,4.2l-3.2,4.1     l3.5,4.2l4.7-2.5c1.2,0.8,2.5,1.6,3.8,2.2l0.2,5.2l5.4,0.9l2.1-5.1c1.5-0.1,2.8-0.4,4.2-0.8l3.6,4l4.8-2.7L35,51.1     C35.9,50.5,36.8,49.5,37.6,48.3 M11.8,39.3c0-6.2,5-11.2,11.2-11.2s11.2,5,11.2,11.2s-5,11.2-11.2,11.2S11.8,45.5,11.8,39.3"></path>
                                <circle class="image-segment-largeinner" cx="22.9" cy="39.3" r="5.5"></circle>
                                <path class="image-segment-largeouter" d="M71.7,45.9l4.5,0.6l1.3-3.7l-4-2.5c0-0.3,0.1-0.7,0.1-1.1c0-0.5-0.1-1.1-0.1-1.6l4-2.5l-1.3-3.7l-4.8,0.7     c-0.5-0.7-1-1.3-1.6-1.8l1.5-4.6l-3.4-1.9l-3.4,3.8c-0.7-0.2-1.5-0.3-2.2-0.3l-1.9-4.7l-3.8,0.7l-0.2,5.2l0.2-0.1     c-0.7,0.3-1.4,0.8-2.1,1.2l0,0l-4.5-2.4l-2.5,3l3.2,4.1l0.2-0.2c-0.4,0.7-0.7,1.5-0.8,2.3l-5,1.1v3.9l5,1.1     c0.2,0.7,0.5,1.5,0.8,2.1l-3.1,3.9l2.5,3l4.4-2.3c0.7,0.5,1.3,0.9,2.1,1.2l0.2,4.8l3.8,0.7l1.8-4.5c0.9-0.1,1.7-0.2,2.5-0.5     l3.2,3.5l3.4-1.9L70,47.9C70.7,47.3,71.2,46.6,71.7,45.9 M61.6,33.2c3.4,0,6.1,2.7,6.1,6.1c0,3.4-2.7,6.1-6.1,6.1     c-3.4,0-6.1-2.7-6.1-6.1C55.5,35.9,58.2,33.2,61.6,33.2"></path>
                            </g>
                        </g>
                    </g>
                    </svg>
                                            </div>
                                            <h5>Enterprise<br> Segmentation Engine</h5>
                                            <p>The segmentation engine stacks complex cohort rules and hyper-targets each visitor into strategic buckets. Our technology marries the visitor’s first party data with their actual on-site behavior to serve the perfect conversion-inducing campaigns.</p>
                    </div>

                    <div class="product-block">
                                            <div class="image-product_block">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="injected-svg image-product image-product-whiteglove inject-svg " x="0" y="0" viewBox="0 0 78.9 79.6" xml:space="preserve" enable-background="new 0 0 78.88 79.56"
                                                    inViewport       
                                                    (enterViewport)="onIconEnter('image-product-whiteglove')"
                                                    (exitViewport)="onIconExit('image-product-whiteglove')">
                    <g>
                        <path class="image-glove-fill" d="M32.8 53.6c0 0-4 6.1 0.9 9 13 7.6 13 13.9 13 13.9l7.8-2 -1.2-3.9 3.3 1.9 4.1-6.9 -3.3-1.9c-0.6-6.6-4.7-9.8-4.7-9.8l4.1-7c0.7-1.1 0.3-2.7-0.9-3.3 -1.1-0.6-2.7-0.3-3.3 0.9 0 0-1.8 3-3.2 5.4 -1.5 2.4-3.7 2.8-6.5 1.1l-2.1-1.2 -3.7 6.3"></path>
                        <path class="image-glove-hand" d="M32.8 53.6c0 0-4 6.1 0.9 9 13 7.6 13 13.9 13 13.9l7.8-2 -1.2-3.9 3.3 1.9 4.1-6.9 -3.3-1.9c-0.6-6.6-4.7-9.8-4.7-9.8l4.1-7c0.7-1.1 0.3-2.7-0.9-3.3 -1.1-0.6-2.7-0.3-3.3 0.9 0 0-1.8 3-3.2 5.4 -1.5 2.4-3.7 2.8-6.5 1.1l-2.1-1.2 -3.7 6.3"></path>
                    </g>

                    <rect x="4" y="42.1" class="image-glove-bkg" width="70.3" height="5"></rect>
                    <g>
                        <path class="image-glove-fill" d="M18.4 50.9c-0.6 1.1-0.3 2.7 0.9 3.3l13.5 7.9c-2.6-2.8-1.1-6.3-1.1-6.3l-10-5.8C20.6 49.3 19.1 49.7 18.4 50.9"></path>
                        <path class="image-glove-hand" d="M18.4 50.9c-0.6 1.1-0.3 2.7 0.9 3.3l13.5 7.9c-2.6-2.8-1.1-6.3-1.1-6.3l-10-5.8C20.6 49.3 19.1 49.7 18.4 50.9z"></path>
                        <path class="image-glove-fill" d="M23.2 48.1c-0.6 1.1-0.3 2.7 0.9 3.3l7.5 4.4 2.4-4.2 -7.4-4.4C25.4 46.5 23.9 46.9 23.2 48.1"></path>
                        <path class="image-glove-hand" d="M23.2 48.1c-0.6 1.1-0.3 2.7 0.9 3.3l7.5 4.4 2.4-4.2 -7.4-4.4C25.4 46.5 23.9 46.9 23.2 48.1z"></path>


                        <path class="image-glove-fill" d="M54.1 65.8c0 0-2 3.9-6.2 3.9"></path>
                        <path class="image-glove-hand" d="M54.1 65.8c0 0-2 3.9-6.2 3.9"></path>

                        <path class="image-glove-fill" d="M32.8 53.6l4.6-7.9c0.7-1.1 2.2-1.5 3.3-0.9 1.1 0.7 1.5 2.2 0.9 3.3l-4.6 7.9c0 0 7.9-1.8 10.6 6.2"></path>
                        <path class="image-glove-hand" d="M32.8 53.6l4.6-7.9c0.7-1.1 2.2-1.5 3.3-0.9 1.1 0.7 1.5 2.2 0.9 3.3l-4.6 7.9c0 0 7.9-1.8 10.6 6.2"></path>
                    </g>
                    <g>
                        <path class="image-glove-dollar" d="M39.2 27.3c-3.1 0-5.6-2.1-5.6-4.7s2.5-4.7 5.6-4.7 5.6 2.1 5.6 4.7"></path>
                        <path class="image-glove-dollar" d="M35.3 25.9c0 0 1.1 1.4 3.9 1.4 3.1 0 5.6 2.1 5.6 4.7s-2.5 4.7-5.6 4.7c-3.1 0-5.6-2.1-5.6-4.7"></path>
                        <line class="image-glove-dollar" x1="39.2" y1="15.6" x2="39.2" y2="39"></line>
                    </g>
                    <g>
                        <line class="image-glove-spokes" x1="21.3" y1="18.1" x2="14.8" y2="13.9"></line>
                        <line class="image-glove-spokes" x1="21.2" y1="33.5" x2="10.3" y2="33.5"></line>
                        <line class="image-glove-spokes" x1="57.1" y1="18.1" x2="63.6" y2="13.9"></line>
                        <line class="image-glove-spokes" x1="57.3" y1="33.5" x2="68.2" y2="33.5"></line>
                        <line class="image-glove-spokes" x1="39.2" y1="3.5" x2="39.2" y2="8.9"></line>
                    </g>
                    </svg>
                                            </div>
                                            <h5>White Glove<br> Marketing Automation</h5>
                                            <p>Our world-class creative team, cutting-edge developer team, and expert conversion specialists combine talents from many practices to move the needle for your business. Our campaigns never stop learning, and you never have to lift a finger.</p>
                    </div>

                    <div class="product-block">
                                            <div class="image-product_block">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon-product-patented injected-svg image-product image-product-patented inject-svg" viewBox="0 0 78.9 79.6" xml:space="preserve" enable-background="new 0 0 78.88 79.56"
                                                    inViewport       
                                                    (enterViewport)="onIconEnter('image-product-patented')"
                                                    (exitViewport)="onIconExit('image-product-patented')">
                                                <defs>
                                                    <style>

                                                    </style>
                                                    <clipPath class="clip-path-patented" id="clip-path-patented-5" transform="translate(-85 -85)">
                                                    <path class="clip-path-patented-path-1" d="M141.3,155.7h-34A13.786,13.786,0,0,1,93.6,142V107.9a13.786,13.786,0,0,1,13.7-13.7h34.1a13.786,13.786,0,0,1,13.7,13.7V142A13.872,13.872,0,0,1,141.3,155.7Z"></path>
                                                    </clipPath>
                                                </defs>
                                                <path class="image-pat-bkg" d="M141.3,155.7h-34A13.786,13.786,0,0,1,93.6,142V107.9a13.786,13.786,0,0,1,13.7-13.7h34.1a13.786,13.786,0,0,1,13.7,13.7V142A13.872,13.872,0,0,1,141.3,155.7Z" transform="translate(-85 -85)"></path>
                                                <g class="image-pat-chipgroup image-pat-chipgroup-top" transform="translate(-29 -19)">
                                                    <rect class="image-pat-chip" x="51.054" y="21.454" width="5.9" height="6.8"></rect>
                                                    <rect class="image-pat-chip" x="60.554" y="21.454" width="5.9" height="6.8"></rect>
                                                    <rect class="image-pat-chip" x="70.154" y="21.454" width="5.9" height="6.8"></rect>
                                                    <rect class="image-pat-chip" x="79.754" y="21.454" width="5.9" height="6.8"></rect>

                                                </g>
                                                <g class="image-pat-chipgroup image-pat-chipgroup-bottom" transform="translate(-29 -19)">
                                                    <rect class="image-pat-chip" x="51.054" y="89.654" width="5.9" height="6.8"></rect>
                                                    <rect class="image-pat-chip" x="60.554" y="89.654" width="5.9" height="6.8"></rect>
                                                    <rect class="image-pat-chip" x="70.154" y="89.654" width="5.9" height="6.8"></rect>
                                                    <rect class="image-pat-chip" x="79.754" y="89.654" width="5.9" height="6.8"></rect>

                                                </g>
                                                <g class="image-pat-chipgroup image-pat-chipgroup-right" transform="translate(-29 -19)">
                                                    <rect class="image-pat-chip" x="99.054" y="41.454" width="6.8" height="5.9"></rect>
                                                    <rect class="image-pat-chip" x="99.054" y="51.054" width="6.8" height="5.9"></rect>
                                                    <rect class="image-pat-chip" x="99.054" y="70.154" width="6.8" height="5.9"></rect>
                                                    <rect class="image-pat-chip" x="99.054" y="60.554" width="6.8" height="5.9"></rect>
                                                </g>
                                                <g class="image-pat-chipgroup image-pat-chipgroup-left" transform="translate(-29 -19)">
                                                    <rect class="image-pat-chip" x="30.854" y="41.454" width="6.8" height="5.9"></rect>
                                                    <rect class="image-pat-chip" x="30.854" y="51.054" width="6.8" height="5.9"></rect>
                                                    <rect class="image-pat-chip" x="30.854" y="60.554" width="6.8" height="5.9"></rect>
                                                    <rect class="image-pat-chip" x="30.854" y="70.154" width="6.8" height="5.9"></rect>
                                                </g>
                                                <path class="image-pat-arrow-outline image-pat-arrow-down" d="M191.7,66.4l-67.8,67.8-4.1-4.1,0.3,15.7h15.3l-3.1-3.1,39.6-38.3" transform="translate(-85 -85)"></path>
                                                <path class="image-pat-arrow-outline image-pat-arrow-up" d="M56.3,182.8L124,115l4.1,4.1-0.3-15.7H112.5l3.1,3.1L76,144.8" transform="translate(-85 -85)"></path>
                                                <g class="arrow-fill-clip-mask">
                                                    <g class="arrow-fill-group">
                                                    <path class="image-pat-arrow-fill image-pat-arrow-down" d="M154.42,103.68L123.9,134.2l-4.1-4.1,0.3,15.7h15.3l-3.1-3.1,22.8-22.052V108.236A13.991,13.991,0,0,0,154.42,103.68Z" transform="translate(-85 -85)"></path>
                                                    <path class="image-pat-arrow-fill image-pat-arrow-up" d="M93.958,145.087L124,115l4.1,4.1-0.3-15.7H112.5l3.1,3.1-22,21.309V142A15.5,15.5,0,0,0,93.958,145.087Z" transform="translate(-85 -85)"></path>
                                                    </g>
                                                </g>
                                                </svg>
                                            </div>
                                            <h5>Patented<br> Conversion Technology</h5>
                                            <p>The behavioral automation technology reads your visitors’ digital body language, targets them in real-time, and then deploys campaigns to power conversions. Find out which digital behaviors our technology looks for by applying for a personal demo.</p>
                    </div>

                </div>
            </div>

			<div class="sec-intent-block sec-intent-intro">
                <h2>Exit Intent<sup>"</sup> Technology</h2>
                <h4>Meet our first behavioral invention.</h4>
				<h5>Find out how we turn abandoning visitors into valuable customers.</h5>
				<p>Here's a little backstory. The first digital behavior we sought out to detect was predicting a visitor's exit-intent. Our technology needed to know when a visitor became disengaged with your website and then was intending on bouncing, possibly to never return.</p>

				<p class="text-desktop">After hundreds of prototypes and iterations, we finally achieved success and were able to accurately predict on any device when a visitor was going to leave <em>before they actually left</em>.</p>
<!-- 				<p class='text-desktop'>Our engineers mapped up the cursor gesture coordinates on every browser/device/operating system combo and looked when+where+at what speed the visitor was breaking the browser plane.</p> -->
				<p class="text-desktop">Armed with the power of knowing when visitors were going to abandon your site, we had the opportunity to try everything we thought would increase conversions. We serve billions of impressions across billions in online revenue. To find out what we learned from these campaigns, apply for a personal demo below.</p>
				<p>After we unlocked exit-intent, we started looking at what other behaviors we could detect from users and how their browsing experiences could be enhanced for maximum conversion revenue.</p>
<!--
				<div class='intent-triggers'>
					[<a href='#sec-intent-mockup' class='intent-start-button'>Test</a>]
				</div>
-->

			</div> <!-- sec-intent-intro -->

			<div class="sec-intent-block sec-intent-device">

				<div class="perspective">
                <div class="card card-overlay card-overlay-animation"  
                    inViewport
                    (enterViewport)="onCardEnter()"
                    (exitViewport)="onCardExit()">
					  <div class="card-shadow"></div>

					</div>

					<div class="card card-desktop">
					  <div class="card-shadow"></div>
					</div>

				</div>

			</div> <!-- .sec-intent-device -->

        </div> 
</div>
</section>

<section class="section-fullscreen sec-testimonials button-light clearfix fp-section fp-table active" data-anchor="testimonials" id="id-testimonials" data-module="home-testimonials" style="height: 524px;"><div class="fp-tableCell" style="height:524px;">

        <div class="wrap"
                inViewport       
    (enterViewport)="toggleDemoButton(true)"
    (exitViewport)="toggleDemoButton(false)">
            <div class="sec-testimonials-block">
                <h3>Proven Across Industries.</h3>

                <div class="flip-container">
                        <div class="flipper">
                            <div class="front">
	                            <div class="table-center">
                                  <h4>Construction</h4>
	                            </div>
                            </div>
                            <div class="back">
	                            <div class="table-center">
		                            <figure>

										<img src="../../../assets/images/home/pchaines.svg" alt="PCHaines" style="width: auto; height: auto;">
										<img src="../../../assets/images/home/buildersinc.svg" alt="Builders Inc" style="width: auto; height: auto;">

		                            </figure>
									<h6><a href="#id-getdemo">Schedule Your Construction Demo</a></h6>

	                            </div>
                            </div>
                        </div>
                </div>

                <div class="flip-container">
                        <div class="flipper">
                            <div class="front">
	                            <div class="table-center">

	                                <h4>Energy</h4>
	                            </div>
                            </div>

                            <div class="back">
	                            <div class="table-center">
		                            <figure>
										<img src="../../../assets/images/home/greenwaysolar.png" alt="YPrime" style="width: auto; height: auto;">
		                            </figure>
									<h6><a href="#id-getdemo">Schedule Your Energy Demo</a></h6>
								</div>
                            </div>
                        </div>
                </div>


                <div class="flip-container">
                        <div class="flipper">
                            <div class="front">
	                            <div class="table-center">
	                                <h4>Healthcare</h4>
								</div>
                            </div>
                            <div class="back">
	                            <div class="table-center">
		                            <figure>
										<img src="../../../assets/images/home/yprime.png" alt="YPrime" style="width: auto; height: auto;">
		                            </figure>

									<h6><a href="#id-getdemo">Schedule Your Healthcare Demo</a></h6>
								</div>
                            </div>
                        </div>
                </div>

                <div class="flip-container">
                        <div class="flipper">
                            <div class="front">
								<div class="table-center">
									<h4>Hospitality</h4>
								</div>
                            </div>
                            <div class="back">
								<div class="table-center">
		                            <figure>
		                            </figure>

									<h6><a href="#id-getdemo">Schedule Your Hospitality Demo</a></h6>
								</div>
                            </div>
                        </div>
                </div>

                <div class="flip-container">
                        <div class="flipper">
                            <div class="front">
								<div class="table-center">
	                                <h4>SaaS</h4>
	                            </div>
                            </div>
                            <div class="back">
								<div class="table-center">
		                            <figure>


										<hr class="break">
                                        <img src="../../../assets/images/home/lightningjobsearch.webp" alt="PontRx" style="width: auto; height: auto;">

			                            <hr class="break">

		                            </figure>

									<h6><a href="#id-getdemo">Schedule Your SaaS Demo</a></h6>
								</div>
                            </div>
                        </div>
                </div>


                <div class="flip-container">
                        <div class="flipper">
                            <div class="front">
								<div class="table-center">
	                                <h4>Startups</h4>
	                            </div>
                            </div>
                            <div class="back">
								<div class="table-center">
		                            <figure>

                                        <img src="../../../assets/images/home/pontrx_logo.svg" alt="PontRx" style="width: auto; height: auto;margin-right: -20px;">
										<img src="../../../assets/images/home/pontrx.svg" alt="PontRx" style="width: auto; height: auto;">

			                            <hr class="break">

		                            </figure>

									<h6><a href="#id-getdemo">Schedule Your Startup Demo</a></h6>
	                            </div>
                            </div>
                        </div>
                </div>


            </div>
        </div> 
</div>
</section>

<section class="section-fullscreen  sec-strategy button-dark fp-section fp-table active" data-anchor="strategy" id="id-strategy" style="height: 524px;"><div class="fp-tableCell" style="height:524px;">

        <div class="wrap">

            <div class="sec-wide-block sec-language-block">
                <div class="image-spec_block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="injected-svg image-spec image-spec-language inject-svg" x="0" y="0" viewBox="0 0 612 625" xml:space="preserve" enable-background="new 0 0 612 625">
                        <path class="image-spec-language-rings" d="M29.3 301.2C30.7 149.7 154.4 26 306.7 26s276.7 123.7 276.7 276.7c0 152.3-123.7 276.7-276.7 276.7C154.4 578.7 29.3 455.1 29.3 301.2z"></path>
                        <path class="image-spec-language-rings" d="M308.1 480.1c-98.7-0.7-178-80.1-178-177.3 0-97.9 79.4-177.3 176.6-177.3s176.6 79.4 176.6 176.6C483.3 400 403.9 480.1 308.1 480.1z"></path>
                        <path class="image-spec-language-rings" d="M308.1 380c-43.6-0.7-77.9-35-77.9-77.2 0-42.9 34.3-77.2 77.2-77.2s77.2 34.3 77.2 77.2C383.9 345 349.6 380 308.1 380z"></path>
                        <line class="image-spec-language-swipe" x1="306.7" y1="302" x2="30.7" y2="530.8"></line>
                        <circle class="image-spec-language-dots" cx="486.9" cy="164.8" r="25.7"></circle>
                        <circle class="image-spec-language-dots" cx="389.6" cy="513" r="25.7"></circle>
                        <circle class="image-spec-language-dots" cx="193.8" cy="251.2" r="25.7"></circle>
                    </svg>
                </div>

                <h2>Digital Body Language</h2>
                <h4>Intelligent Behavioral Technology.</h4>
                <ul>
	                <li><h5><em>Your individual visitors are telling you a compelling story</em> with their digital behavior.</h5></li>
					<li><h5>Some exhibit engagement and conversion intent, while others convey disengagement patterns. </h5></li>
					<li><h5>It's time to reengage the abandoners, nudge procrastinators, and <em>keep the high-intents on the conversion track</em>.</h5></li>
                </ul>
            </div>

            <div class="sec-wide-block sec-strategy-block">
	            <div class="image-spec_block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="injected-svg image-spec image-spec-strategy inject-svg" x="0" y="0" viewBox="0 0 612 625" xml:space="preserve" enable-background="new 0 0 612 625">
                    <style type="text/css">
                    
                    </style>
                        <g class="image-spec-strategy-frame">
                            <rect x="51.8" y="41.4" class="image-spec-strategy-frame" width="517.6" height="380"></rect>
                            <line class="image-spec-strategy-base" x1="21.6" y1="421.4" x2="594.3" y2="421.4"></line>
                            <polygon class="image-spec-strategy-legs" points="439 422.2 473.7 527 517 527 482.3 422.2 "></polygon>
                            <polygon class="image-spec-strategy-legs" points="133.7 422.2 98.9 527 142.2 527 176.9 422.2 "></polygon>
                        </g>
                        <g class="image-spec-strategy-os">
                            <circle class="image-spec-strategy-o" cx="176.9" cy="306.8" r="26.2"></circle>
                            <circle class="image-spec-strategy-o" cx="131" cy="175.7" r="26.2"></circle>
                            
                            <polyline class="image-spec-strategy-arrow" points="296.1 205.2 324.3 221 308.6 248.5 "></polyline>
                            <path class="image-spec-strategy-path" d="M195.9 288.4C252.2 240 321 221.6 321 221.6"></path>
                            <circle class="image-spec-strategy-o" cx="411.5" cy="135.8" r="26.2"></circle>
                        </g>

                        <g class="image-spec-strategy-x">
                            <line x1="279.1" y1="139.7" x2="237.2" y2="98.4"></line>
                            <line x1="237.2" y1="139.7" x2="279.1" y2="98.4"></line>

                            <line x1="476.3" y1="278" x2="434.4" y2="236"></line>
                            <line x1="434.4" y1="278" x2="476.3" y2="236"></line>

                            <line x1="370.8" y1="348.7" x2="328.9" y2="307.5"></line>
                            <line x1="328.9" y1="348.7" x2="370.8" y2="307.5"></line>
                        </g>
                    </svg>	            
                </div>

                <h2>Conversion Strategy</h2>
                <h4>Your Business Objectives.<hr class="break"> Our Custom Uplift Roadmap.</h4>
                <ul>
                    <li><h5>Maximize your revenue per visitor by leveraging insights from the 3 billion behavioral impressions we run across our network weekly.</h5></li>
                    <li><h5>Customized automation <em>unique to your business</em>, your site and your real time audience.</h5></li>
                    <li><h5>Let's give time back to your internal team. <em>Implementation, building, and iteration is our responsibility</em>.</h5></li>
                </ul>
            </div>

            <div class="sec-wide-block sec-impact-block">
	            <div class="image-spec_block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="icon-spec-impact injected-svg image-spec image-spec-impact inject-svg" x="0" y="0" viewBox="0 0 612 600" xml:space="preserve" enable-background="new 0 0 612 600">
                        <g class="image-spec-strategy-screen">
                            <rect x="247.1" y="391.1" class="image-spec-strategy-screenfill" width="108.4" height="108.4"></rect>
                            <line class="image-spec-strategy-screenframe image-spec-strategy-bkg" x1="177.8" y1="495.9" x2="429.4" y2="495.9"></line>
                            <path class="image-spec-strategy-screenframe" d="M568.7 423.6H50.3c-2.2 0-2-0.3-2-2.6V42.5c0-2.2-0.2-2 2-2h515.8c2.2 0 2.6-0.2 2.6 2V423.6C568.7 423.3 568.3 423.6 568.7 423.6z"></path>
                            <path class="image-spec-strategy-screenfill" d="M565.1 420H50.3c-2.2 0-5.6-2.1-5.6-4.3v-60.7h527.6v60.7C572.3 417.9 568.3 420 565.1 420z"></path>
                        </g>

                        <g class="image-spec-strategy-grid">
                        <line x1="135" y1="45.4" x2="135" y2="356.7"></line>
                        <line x1="221.8" y1="45.4" x2="221.8" y2="356.7"></line>
                        <line x1="308.5" y1="45.4" x2="308.5" y2="356.7"></line>
                        <line x1="402.5" y1="45.4" x2="402.5" y2="356.7"></line>
                        <line x1="489.2" y1="45.4" x2="489.2" y2="356.7"></line>
                        <line x1="564.4" y1="112.8" x2="53.5" y2="112.8"></line>
                        <line x1="564.4" y1="199.5" x2="53.5" y2="199.5"></line>
                        <line x1="564.4" y1="286.3" x2="53.5" y2="286.3"></line>
                        </g>
                    
                        <polyline class="image-spec-strategy-path" points="53.5 356.7 174.5 235.9 219.8 283.7 309 151.7 357.2 200.4 529.3 76.3 "></polyline>

                    </svg>
	            </div>

                <h2>Progressive Impact</h2>
                <h4>We Don't Empower Marketers.<hr class="break"> We Empower Your Bottom Line.</h4>
                <ul>

                    <li><h5><em>Do you want on-site marketing automation</em> leveraging behavioral segments built to increase conversion rates?</h5></li>
                    <li><h5>Are you ready to see a clear return on investment, backed by <em>hard numbers</em> that break business records?</h5></li>
                    <li><h5>There are no magic wands. There are no silver bullets. <em>There is bouncd</em>.</h5></li>

                </ul>
            </div>

        </div> 
</div>
</section>

<!-- Video FMA 
<section class="section-fullscreen sec-video button-light fp-section fp-table active" data-anchor="video" id="id-video" style="height: 477px;"><div class="fp-tableCell" style="height: 477px;">
        <div class="wrap">
            <div class="sec-video-block">
                <div class="video-copy">

                    <h1>How it Works.</h1><h1>Push Button.</h1>
                    <h4>If you are reading this, you didn’t push play yet.</h4>
                </div>
            </div>
        </div> 
        <div class="fullscreen-height video-module" style="height: 477px;">
    <button class="btn-overlay-video-play bottom-video">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve" class="injected-svg inject-svg overlay-play-image">
<g>
	<circle opacity="0.5" fill="#F7C2A0" cx="49.6" cy="50" r="47.6"></circle>
	<polygon fill="#FF7F00" points="37.5,75.5 37.5,24.6 72.3,50  "></polygon>
</g>
</svg>
    </button>

    <div class="fullscreen-height overlay-video" data-state="hidden">
      <div class="overlay-video-container">
        <div class="backdrop"> </div>
        <div class="overlay-video-sizer">
        </div>
      </div>
    </div>
</div>

</div>
</section>
-->

<app-get-demo-form 
    inViewport       
    (enterViewport)="toggleDemoButton(true)"
    (exitViewport)="toggleDemoButton(false)">
</app-get-demo-form>

</div>
</article>
